import ReactDOM from 'react-dom/client';
import { Suspense, StrictMode } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';

import { CONFIG } from './config-global';
import { routes } from './routes/sections';

// ----------------------------------------------------------------------

const router = createBrowserRouter(routes, { basename: CONFIG.site.basePath });

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <StrictMode>
    <HelmetProvider>
      <Suspense>
        <RouterProvider router={router} />
      </Suspense>
    </HelmetProvider>
  </StrictMode>
);
